// extracted by mini-css-extract-plugin
export var _default = "footer-module--_default--fc87u";
export var bank_cards_wrapper = "footer-module--bank_cards_wrapper--i9xEE";
export var connection = "footer-module--connection--YxR0Y";
export var description = "footer-module--description--R0THo";
export var feedback_button = "footer-module--feedback_button--I4q5T";
export var footer = "footer-module--footer--E4dvS";
export var footer_about_system = "footer-module--footer_about_system--rTkuE";
export var footer_sections = "footer-module--footer_sections--EHef+";
export var footer_wrapper = "footer-module--footer_wrapper--G+Rf7";
export var icon_text = "footer-module--icon_text--TY43x";
export var logo_card_wrapper = "footer-module--logo_card_wrapper--1PaIF";
export var logo_rights = "footer-module--logo_rights--m2fsl";
export var payments_logo = "footer-module--payments_logo--+2Jt1";
export var primary = "footer-module--primary--p2RMR";
export var secondary = "footer-module--secondary--Nuuhq";
export var secondary_display = "footer-module--secondary_display--ZCaRP";
export var section_wrapper = "footer-module--section_wrapper--LZSAJ";
export var section_wrapper_description = "footer-module--section_wrapper_description--XnA31";
export var section_wrapper_link = "footer-module--section_wrapper_link--0IMTm";
export var sections = "footer-module--sections--g+POf";
export var sections_general_text = "footer-module--sections_general_text--ViCWj";
export var sections_resources = "footer-module--sections_resources--tlCcp";
export var sections_resources_wrapper = "footer-module--sections_resources_wrapper--fXqa0";
export var social_link_container = "footer-module--social_link_container--txPpk";
export var social_links = "footer-module--social_links--hdhfm";
export var title = "footer-module--title--0h+DL";